import { AppActionType, AppAction, AppState } from './types';
import { updateSelectedFilters, toggleFilterTag } from 'util/resource-util';

const initialState: AppState = {
  app: null,
  locale: 'en-US',
  pdfScaleValue: 1,
  previousWorkbook: null,
  currentWorkbook: null,
  character: {
    selectedCharacter: {
      characterType: '',
      characterCase: '',
      character: '',
      data: {
        url: '#'
      }
    }
  },
  resource: {
    showResourcePlayer: false,
    selectedResource: {
      id: 0,
      type: '',
      mediaType: '',
      url: '',
      title: '',
      aspectRatio: '',
      heightAdjust: 125,
      fileExtension: '',
      resourceTypeId: 0,
      data: { fileExtension: '', mediaType: '', src: '' }
    },
    selectedFilters: {
      searchText: '',
      selectedTags: []
    }
  },
  selectedClassroomId: '',
  showLoadingScreen: false,
  counter: null
};

const appReducer = (state: AppState = initialState, action: AppAction | any): AppState => {
  switch (action.type) {
    // TODO replace with provider?
    case AppActionType.APP_TOGGLE_APP_LOADING_SCREEN_VISIBILITY:
      return {
        ...state,
        showLoadingScreen: !state.showLoadingScreen
      };
    case AppActionType.APP_TOGGLE_TAG:
      return {
        ...state,
        resource: {
          ...state.resource,
          selectedFilters: updateSelectedFilters(state, {
            searchText: '',
            selectedTags: toggleFilterTag(state.resource.selectedFilters.selectedTags, action.tag)
          })
        }
      };
    case AppActionType.APP_CLEAR_RESOURCE_FILTERS:
      return {
        ...state,
        resource: {
          ...state.resource,
          selectedFilters: {
            searchText: state.resource.selectedFilters.searchText,
            selectedTags: []
          }
        }
      };
    case AppActionType.CHANGE_APP_LOCALE:
      return {
        ...state,
        locale: action.data
      };
    case AppActionType.ZOOM_PDF: {
      const newPdfScaleValue = action.data
        ? parseFloat((state.pdfScaleValue + action.data).toFixed(2)) <= 3
          ? parseFloat((state.pdfScaleValue + action.data).toFixed(2))
          : state.pdfScaleValue
        : parseFloat((state.pdfScaleValue - action.data).toFixed(2)) >= 1
        ? parseFloat((state.pdfScaleValue - action.data).toFixed(2))
        : 1;

      return {
        ...state,
        pdfScaleValue: newPdfScaleValue
      };
    }
    case AppActionType.SET_SCALE_PDF:
      return {
        ...state,
        pdfScaleValue: action.data
      };
    case AppActionType.SET_RESOURCE_FILTERS:
      return {
        ...state,
        resource: {
          ...state.resource,
          selectedFilters: updateSelectedFilters(state, action.data)
        }
      };
    case AppActionType.SELECT_RESOURCE:
      return {
        ...state,
        resource: {
          ...state.resource,
          selectedResource: action.data
        }
      };
    case AppActionType.TOGGLE_RESOURCE_PLAYER_VISIBILITY:
      return {
        ...state,
        resource: {
          ...state.resource,
          showResourcePlayer: !state.resource.showResourcePlayer
        }
      };
    case AppActionType.SELECT_CHARACTER:
      return {
        ...state,
        character: {
          selectedCharacter: action.data
        }
      };
    case AppActionType.SET_APP_ID:
      return {
        ...state,
        app: action.data
      };
    case AppActionType.CURRENT_WORKBOOK: {
      return {
        ...state,
        previousWorkbook: state.currentWorkbook,
        currentWorkbook: action.currentWorkbook,
        selectedClassroomId: ''
      };
    }
    case AppActionType.UPDATE_COUNTER: {
      const { operationType } = action;

      return {
        ...state,
        counter:
          operationType === 'reset'
            ? 0
            : operationType === 'increment'
            ? state.counter + 1
            : state.counter - 1
      };
    }
    case AppActionType.SELECT_CLASSROOM:
      return {
        ...state,
        selectedClassroomId: action.data.classroomId
      };
    case AppActionType.CLEAR_SELECTED_CLASSROOM:
      return {
        ...state,
        selectedClassroomId: ''
      };
    default:
      return state;
  }
};

export default appReducer;
